import { deleteRequest } from "../../api/requests.api";

export async function deleteContactRequests(requests){

    requests.map(req => {
        deleteRequest(req._id)
        /* console.log(`petición ${req._id} borrada`) */
    })
    
}